module.exports = __webpack_public_path__ + "img/sankaku_96_blue.d99bbdcb.png";